import { PartyType } from 'generated/gql';
import type { StepProps } from '@rulebooks/evidend-titan';
import { WizardContent } from 'components/Wizard/WizardContent';
import type { RegisterMutation } from 'generated/gql';
import { getPartyTypeUrl } from 'helpers/getFromParty';
import React from 'react';

import { useWizardContext } from './useWizardContext';

export interface IWizard {
  children: React.ReactNode;
  closeTo?: string;
  defaultStep: string | ((mutation: RegisterMutation) => string);
  stepValidator: (step: string, steps: StepProps[]) => boolean;
}

export const Wizard = ({ children, ...props }: IWizard) => {
  const { step, steps, visitStep, mutation } = useWizardContext();

  const partyUrl = getPartyTypeUrl({
    type: PartyType.LegalEntity,
    id: mutation.register.legalEntity.id,
  });
  return (
    <WizardContent
      closeTo={`${partyUrl}?tab=Mutaties`}
      mutation={mutation}
      mutationType={mutation.type}
      step={step}
      steps={steps}
      visitStep={visitStep}
      {...props}
    >
      {children}
    </WizardContent>
  );
};
